import { useEffect, useState } from "react";
import { InputController } from "../../../../hooks/input-controller";
import { UseApi } from "../../../../hooks/use-api";
import { ToastEmitter } from "../../../../Services/assets/toast-emitter";
import { GetAddressList } from "../../../../Services/lib/brand";
import Disclaimer from "../../../Disclaimer";
import TextInput from "../../../TextInput";
import styles from "./Approved.module.sass";
import UserAddress from "./user-address";
import classNames from "classnames";
import Loader from "../../../Loader";
import { useUser } from "../../../../context";
import nft_product from "../../../../i11/Nft_Product";
import { Shipment } from "../../../../Services/lib/shipping";

const Approved = ({ item, body, refresh }) => {
	const { locale } = useUser();
	const [{ isLoading: isLoadingShip, error }, ship] = UseApi({
		service: Shipment,
	});

	const update_ = async () => {
		const { chosenNftId, shipmentDescription, shipperPhone } = shipData;
		const res = await ship({
			chosenNftId,
			shipmentDescription,
			shipperPhone,
		});
		if (res) {
			refresh();
			ToastEmitter({
				msg: "Successfully shipped",
				type: "success",
			});
		}
	};

	useEffect(() => {
		if (error) {
			const data = error.response.data;
			console.log(data);
			if (data?.response?.errors) {
				let tmp = `Following error${
					data?.response?.errors.length > 1 ? "s" : ""
				} occured: `;
				data?.response?.errors.map(
					(e, i) =>
						(tmp += `${e.message}${
							i < data?.response?.errors.length - 1 ? ", " : ""
						} `)
				);
				ToastEmitter({
					msg: tmp,
					type: "error",
				});
			}
		}
	}, [error]);

	const [shipData, setShipData] = useState({
		chosenNftId: item._id,
		shipmentDescription: "",
		shipperPhone: "",
		packageDescription: "",
		dimensionsMeasurementCode: "IN",
		dimensionsLength: item.shippingInfo?.length || "",
		dimensionsWidth: item.shippingInfo?.width || "",
		dimensionsHeight: item.shippingInfo?.height || "",
		packageCode: "02",
		packageWeightMeasurementCode: "LBS",
		packageWeight: item.shippingInfo?.weight || "",
	});

	const HandleSubmit = (e) => {
		e.preventDefault();
		update_();
	};

	return (
		<div className={styles.container}>
			<form onSubmit={HandleSubmit}>
				<div className={styles.subContainer}>
					<Brand
						shipData={shipData}
						item={item}
						setShipData={setShipData}
					/>
					<Goods shipData={shipData} setShipData={setShipData} />
					<To item={item} />
					<div />
					<div
						className={classNames(styles.flex, {
							disabled: isLoadingShip,
						})}
					>
						<button className="button">
							{isLoadingShip && <Loader />}
							{nft_product[locale].confirm_ship}
						</button>
					</div>
				</div>
			</form>
			<div>
				<Disclaimer>{nft_product[locale].diclaimer_app}</Disclaimer>
			</div>
		</div>
	);
};

const Brand = ({ shipData, setShipData, item }) => {
	const { brand, locale } = useUser();
	const shipperPhone = InputController("shipperPhone", setShipData);
	const shipperFaxNumber = InputController("shipperFaxNumber", setShipData);
	const [{ data: addresses }, getAddresses] = UseApi({
		service: GetAddressList,
	});
	const [dictionaryAddr, setDictionaryAddr] = useState({});
	const getAddresses_ = async () => {
		const res = await getAddresses();
		if (res) {
			const tmp = {};
			res.forEach((element) => {
				tmp[element._id] = {
					title: element.AddressLineString + ", " + element.Region,
				};
			});
			setDictionaryAddr(tmp);
		}
	};
	useEffect(() => {
		if (brand) {
			setShipData((p) => {
				return { ...p, shipperPhone: brand.phoneNumber };
			});
		}
	}, [brand]);
	useEffect(() => {
		getAddresses_();
	}, []);
	return (
		<>
			<div className="body1-m">
				<TextInput
					required
					disabled
					value={nft_product[locale].brand}
				/>
			</div>
			<div className="body1-m">
				<div>
					<TextInput
						required
						value={shipData.shipperPhone}
						{...shipperPhone}
						placeholder="Phone "
					/>
				</div>
				<div>
					<TextInput
						disabled
						value={brand.taxId}
						placeholder={nft_product[locale].tax_id}
					/>
				</div>
				<div>
					<TextInput
						classInput={styles.classTxtarea}
						required
						{...shipperFaxNumber}
						disabled
						textarea
						value={
							dictionaryAddr[item.shippingInfo?.pickupAddressID]
								?.title
						}
					/>
				</div>
			</div>
		</>
	);
};

const Goods = ({ shipData, setShipData }) => {
	const { locale } = useUser();
	const packageWeight = InputController("packageWeight", setShipData);
	const dimensionsHeight = InputController("dimensionsHeight", setShipData);
	const dimensionsWidth = InputController("dimensionsWidth", setShipData);
	const dimensionsLength = InputController("dimensionsLength", setShipData);

	return (
		<>
			<div className="body1-m">
				<TextInput
					required
					disabled
					value={nft_product[locale].goods}
				/>
			</div>
			<div className="body1-m">
				<div>
					<TextInput
						required
						disabled
						value={shipData.packageWeight}
						placeholder={nft_product[locale].weight}
						currency="Lbs"
						{...packageWeight}
					/>
				</div>
				<div>
					<TextInput
						required
						disabled
						value={shipData.dimensionsHeight}
						label={nft_product[locale].dimensions}
						placeholder={nft_product[locale].height}
						currency="Inch"
						{...dimensionsHeight}
					/>
				</div>
				<div>
					<TextInput
						required
						disabled
						value={shipData.dimensionsWidth}
						placeholder={nft_product[locale].width}
						currency="Inch"
						{...dimensionsWidth}
					/>
				</div>
				<div>
					<TextInput
						required
						disabled
						value={shipData.dimensionsLength}
						placeholder={nft_product[locale].length}
						currency="Inch"
						{...dimensionsLength}
					/>
				</div>
			</div>
		</>
	);
};

const To = ({ item }) => {
	const { locale } = useUser();
	return (
		<>
			<div className="body1-m">
				<TextInput required disabled value={nft_product[locale].to} />
			</div>
			<div className="body1-m">
				<div>
					<TextInput
						disabled
						required
						value={item?.owner?.userName}
					/>
				</div>
				<UserAddress item={item} />
			</div>
		</>
	);
};

export default Approved;
